import { SCORE_TYPE } from '../../../common/header/companyInfo/constant'

export const SCORE_KEY = {
  [SCORE_TYPE.CREDIT_RISK]: {
    TOOLTIP: '',
    SCORE: 'creditRiskScore',
  },
  [SCORE_TYPE.PERFORMANCE]: {
    TOOLTIP: 'performanceDescription',
    SCORE: 'performanceScore',
  },
}
